import { InboxIcon } from '@heroicons/react/24/outline'
import type { ReactNode } from 'react'

interface EmptyStateProps {
  title: string
  description?: string
  action?: ReactNode
}

export const EmptyState = ({ title, description, action }: EmptyStateProps) => {
  return (
    <div className="rounded-box border border-dashed border-base-300 bg-base-200/30 p-10 text-center">
      <div className="flex justify-center mb-3">
        <InboxIcon className="w-8 h-8 opacity-50" />
      </div>
      <h3 className="text-lg font-semibold">{title}</h3>
      {description ? (
        <p className="mt-2 text-sm opacity-80">{description}</p>
      ) : null}
      {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
    </div>
  )
}
